import { render, staticRenderFns } from "./shareResources.vue?vue&type=template&id=5c3770d8&"
import script from "./shareResources.vue?vue&type=script&lang=js&"
export * from "./shareResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports